export type KnowledgeDiscoveryJiraIntentDetectionModelType =
	(typeof KnowledgeDiscoveryJiraIntentDetectionModel)[keyof typeof KnowledgeDiscoveryJiraIntentDetectionModel];

/**
 * Model type for Jira search intent.
 */
export const KnowledgeDiscoveryJiraIntentDetectionModel = {
	GNIN_HEURISTIC: 'GNIN_HEURISTIC',
	FPS_HEURISTIC: 'FPS_HEURISTIC',
} as const;
